export { SkeletonLoader as Loader } from './Skeleton'
export { SkeletonHeading as Heading } from './SkeletonHeading'
export { SkeletonButton as Button } from './SkeletonButton'
export { SkeletonTabs as Tabs } from './SkeletonTabs'
export { SkeletonDoughnutChart as DoughnutChart } from './SkeletonDoughnutChart'
export { SkeletonTable as Table } from './SkeletonTable'
export { SkeletonCard as Card } from './SkeletonCard'
export { SkeletonColumnChart as ColumnChart } from './SkeletonColumnChart'
export { SkeletonBarChart as BarChart } from './SkeletonBarChart'
export { SkeletonPanelList as PanelList } from './SkeletonPanelList'
export { SkeletonSubjectList as SubjectList } from './SkeletonSubjectList'
